<template>
  <v-app>
    <!-- Header -->
    <Header/>
    <!-- router -->
    <router-view/>
    <!-- Footer -->
    <Footer/>
  </v-app>
</template>

<script>

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components:{
    Header,
    Footer
  }
};
</script>